module.exports = __webpack_public_path__ + "img/car-safety.718cd813.jpg";